:host {
  display: block;
}

.cwru-center {
  box-sizing: content-box;
  margin-left: auto;
  margin-right: auto;
  text-align: inherit;
  max-width: var(--max);
  padding-left: var(--gutters);
  padding-right: var(--gutters);
}

.cwru-center.center {
  text-align: center;
}

.cwru-center.intrinsic {
  display: flex;
  flex-direction: column;
  align-items: center;
}
